var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarMonth = function SvgCalendarMonth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "calendar-month_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 14v-2h2v2zm-4 0v-2h2v2zm8 0v-2h2v2zm-4 4v-2h2v2zm-4 0v-2h2v2zm8 0v-2h2v2zM3 22V4h3V2h2v2h8V2h2v2h3v18zm2-2h14V10H5zM5 8h14V6H5zm0 0V6z"
  })));
};
export { SvgCalendarMonth as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTEgMTRWMTJIMTNWMTRIMTFaTTcgMTRWMTJIOVYxNEg3Wk0xNSAxNFYxMkgxN1YxNEgxNVpNMTEgMThWMTZIMTNWMThIMTFaTTcgMThWMTZIOVYxOEg3Wk0xNSAxOFYxNkgxN1YxOEgxNVpNMyAyMlY0SDZWMkg4VjRIMTZWMkgxOFY0SDIxVjIySDNaTTUgMjBIMTlWMTBINVYyMFpNNSA4SDE5VjZINVY4Wk01IDhWNlY4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";